export const navItems = [
    { label: 'Home', href: '/' },
    { label: 'PulseLogic', href: '/pulselogic' },
    { label: 'RadSum', href: '/radsum' },
    { label: 'About', href: '/about' },
    { label: 'Contact', href: '/contact' },
];
